module.exports = __webpack_public_path__ + "static/media/Left legs05.e76ca4f2.png";